import { RiNewspaperLine } from '@remixicon/react'
import {
  Perm_Advance_View,
  Perm_MenuReport_View,
  Perm_OfferToPay_View,
  Perm_Order_Report_Kt,
  Perm_Reimburse_View
} from '../../app/hooks/premissionScreen'
import { createCollapseGroup, createItem } from '../../help'
import ROUTES from '../../routers/helpersRouter/constantRouter'
import { MenuItem } from '../../types'

const icons = {
  RiNewspaperLine
}

export const reportMenuItem: MenuItem[] = [
  createCollapseGroup({
    id: 'list-report',
    title: 'Báo cáo',
    icon: icons.RiNewspaperLine,
    iconActive: icons.RiNewspaperLine,
    premissions: Perm_MenuReport_View,
    children: [
      createItem({
        id: 'report-dntt',
        title: 'Phiếu ĐNTT',
        url: `/${ROUTES.REPORT}/${ROUTES.REPORT_CHILD.OFFER_TO_PAY}`,
        premissions: Perm_OfferToPay_View
      }),
      createItem({
        id: 'report-advance',
        title: 'Tạm ứng',
        url: `/${ROUTES.REPORT}/${ROUTES.REPORT_CHILD.ADVANCE}`,
        premissions: Perm_Advance_View
      }),
      createItem({
        id: 'report-reimburse',
        title: 'Hoàn ứng',
        url: `/${ROUTES.REPORT}/${ROUTES.REPORT_CHILD.REIMBURSE}`,
        premissions: Perm_Reimburse_View
      }),
      createItem({
        id: 'report-kt',
        title: 'Báo cáo kết toán',
        url: `/${ROUTES.REPORT}/${ROUTES.REPORT_CHILD.REPORT_KT}`,
        premissions: Perm_Order_Report_Kt
      }),
      createItem({
        id: 'report-checklist',
        title: 'Bảng kê',
        url: `/${ROUTES.REPORT}/${ROUTES.REPORT_CHILD.REPORT_CHECK_LIST}`,
        premissions: Perm_Order_Report_Kt
      })
    ]
  })
]
